import { render, staticRenderFns } from "./StudyInfo.vue?vue&type=template&id=585b3dc0&"
import script from "./StudyInfo.vue?vue&type=script&lang=js&"
export * from "./StudyInfo.vue?vue&type=script&lang=js&"
import style0 from "./StudyInfo.vue?vue&type=style&index=0&id=585b3dc0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports